import React from "react";
import { Location } from "@reach/router";
import { formatFuzzyDate } from "./../../modules/time";
import { ObjectHeaderDiv } from "./elements";

const ObjectHeader = ({
  title,
  subtitle,
  date,
  dateApproximateness,
  endDate,
  endDateApproximateness,
}) => {
  const isRange = Boolean(endDate);
  return (
    <Location>
      {({ location }) => {
        const myUrl = location.origin + location.pathname;
        return (
          <ObjectHeaderDiv>
            <h2>
              {title} {subtitle ? <em>{subtitle}</em> : null}
            </h2>
            {date ? (
              <h3>
                {isRange
                  ? `${formatFuzzyDate(
                      date,
                      dateApproximateness
                    )}–${formatFuzzyDate(
                      endDate,
                      endDateApproximateness || dateApproximateness
                    )}`
                  : formatFuzzyDate(date, dateApproximateness)}
              </h3>
            ) : null}
            <h4>
              Link to this page: <a href={myUrl}>{myUrl}</a>
            </h4>
          </ObjectHeaderDiv>
        );
      }}
    </Location>
  );
};

export default ObjectHeader;
